/**
 * 额外补贴svg
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/7
 */
import React from 'react';

const Subsidy = () => {
  return <svg viewBox="0 0 1024 1024" className="store-svg-subsidy">
    <path d="M703.074 78.589h-590.309c-26.409 0-38.836 32.622-38.836 57.477v714.585c0 26.409 13.981 35.73 38.836 35.73h302.922v-31.069h-302.922c-9.321 0-7.767 4.66-7.767-4.66v-714.585c0-9.321 0-26.409 7.767-26.409h590.309c9.321 0 23.301 18.641 23.301 26.409v284.281h31.069v-282.727c0-26.409-27.962-59.031-54.371-59.031z" />
    <path d="M389.278 620.741h-108.741v-31.069h108.741v-62.138h-108.741v-31.069h86.993l-118.062-186.414h31.069c0 0 107.188 156.898 124.276 186.414v0c18.641-29.515 124.276-186.414 124.276-186.414h31.069l-116.509 186.414h85.439v31.069h-108.741v62.138h108.741v31.069h-108.741v77.673h-31.069v-77.673z" />
    <path d="M749.677 945.411c-110.295 0-200.395-90.099-200.395-200.395s90.099-200.395 200.395-200.395 200.395 90.099 200.395 200.395-88.546 200.395-200.395 200.395zM749.677 572.585c-94.759 0-172.432 77.673-172.432 172.432s77.673 172.432 172.432 172.432 172.432-77.673 172.432-172.432-77.673-172.432-172.432-172.432z" />
    <path d="M637.829 729.483h217.483v31.069h-217.483v-31.069z" />
    <path d="M731.036 636.276h31.069v217.483h-31.069v-217.483z" />
  </svg>
};

export default Subsidy


// WEBPACK FOOTER //
// ./src/svgs/subsidy.js